export default __webpack_public_path__ + "static/media/luke-porter-NEqEC7qa9FM-unsplash.197872a0.jpg";